import { isScrollable } from './is-scrollable';

export function prepareFocus(node: HTMLElement) {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT);
  let n: Node | null;
  while ((n = walker.nextNode())) {
    if (n instanceof HTMLElement) {
      const el = n as HTMLElement;
      const [x, y] = isScrollable(el);
      if (x || y) el.tabIndex = 0;
    }
  }
  node.focus();
}
